/**
 * Sipariş kanalı (pazaryeri) eşlemesi — TEK kaynak.
 *
 * Kodlar backend `MarketplaceType` enum'u ile birebirdir (Enums.cs):
 * 0 Unknown · 1 Trendyol · 2 Getir · 3 Migros · 4 Yemeksepeti · 5 Phone · 6 InHouse · 7 Hızlıyo
 * 11 TgoMarket (Uber Eats Market) · 12 YsMarket (Yemeksepeti Market) · 13 CarsiMarket (Getir Çarşı) — ad, renk ve logo
 * partner panelindeki market kartlarıyla aynı.
 *
 * Görseller partner panelindeki dosyalarla AYNI: kurye aynı markayı iki panelde farklı
 * görselde görmemeli. Marka renkleri rozet zeminine değil yalnız ince kenarlığa uygulanır —
 * liste satırında dört farklı dolgu renk gürültü yaratıyordu.
 */
export const MARKETPLACES = {
    1: { label: 'Trendyol Yemek', short: 'Trendyol', logo: '/images/trendyolyemek.png', color: '#f27a1a' },
    2: { label: 'Getir Yemek', short: 'Getir', logo: '/images/getiryemek.png', color: '#5d3ebc' },
    3: { label: 'Migros Yemek', short: 'Migros', logo: '/images/migrosyemek.png', color: '#f27a1a' },
    4: { label: 'Yemeksepeti', short: 'Yemeksepeti', logo: '/images/yemeksepeti.png', color: '#fa0050' },
    5: { label: 'Telefon siparişi', short: 'Telefon', logo: '/images/telefon.svg', color: '#71717a' },
    6: { label: 'Restoran içi sipariş', short: 'Restoran içi', logo: null, color: '#71717a' },
    7: { label: 'Hızlıyo', short: 'Hızlıyo', logo: '/images/hizliyo.png', color: '#22c55e' },
    11: { label: 'Uber Eats Market (Trendyol Go)', short: 'Uber Eats Market', logo: '/images/ubereats.png', color: '#06C167' },
    12: { label: 'Yemeksepeti Market', short: 'Yemeksepeti Market', logo: '/images/yemeksepeti.png', color: '#EA004B' },
    13: { label: 'Getir Çarşı', short: 'Getir Çarşı', logo: '/images/getiryemek.png', color: '#5D3EBC' },
};

/**
 * Dış POS (entegratör) kanalı. Pazaryeri DEĞİL, bu yüzden MARKETPLACES içinde yer almaz:
 * paketi gönderen restoran Hızlıyo'ya kayıtlı değil, ücretini filoya doğrudan ödüyor.
 * O paketin MarketplaceType'ı Unknown gelir — ayırt eden alan `isIntegrationChannel`.
 * Renk CRM sipariş listesiyle AYNI (#0ea5e9): aynı paket iki panelde aynı renkte görünsün.
 */
export const INTEGRATION_CHANNEL = {
    label: 'Dış POS entegrasyonu',
    short: 'Dış POS',
    logo: null,
    color: '#0ea5e9',
};

/**
 * Kanal bilgisi; bilinmeyen/0/null için null döner — çağıran rozeti hiç çizmez.
 * "Bilinmiyor" etiketi basmak bilgi değil gürültüdür.
 */
export function getMarketplace(code) {
    if (code == null) return null;
    return MARKETPLACES[Number(code)] || null;
}

/**
 * Teslimatın geldiği kanal — pazaryeri ya da dış POS. Rozetin çizilip çizilmeyeceğine
 * karar veren yer burası; çağıranlar iki alanı ayrı ayrı sorgularsa biri unutulur.
 */
export function getDeliveryChannel(delivery) {
    if (!delivery) return null;
    if (delivery.isIntegrationChannel) return INTEGRATION_CHANNEL;
    return getMarketplace(delivery.marketplaceCode);
}
